var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookClosedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 13.125V1.875C17.5001 0.839453 16.6602 0 15.6251 0H3.75006C1.67897 0 6.10352e-05 1.67891 6.10352e-05 3.75V16.25C6.10352e-05 18.3211 1.67897 20 3.75006 20H16.2501C16.9403 20 17.5001 19.4402 17.5001 18.7852C17.5001 18.3273 17.242 17.9445 16.8751 17.7266V14.5484C17.2579 14.1719 17.5001 13.6797 17.5001 13.125ZM15.0001 17.5H3.75006C3.05983 17.5 2.50006 16.9402 2.50006 16.25C2.50006 15.5598 3.05983 15 3.75006 15H15.0001V17.5Z",
    fill: "#646471"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookClosedIcon);
export default __webpack_public_path__ + "static/media/book-closed-icon.682b2f35.svg";
export { ForwardRef as ReactComponent };